import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import { Alert, Skeleton,Table, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs, Drawer, Popconfirm, Switch, List, Typography } from "antd";
import { CopyOutlined , DeleteOutlined, EditOutlined, EyeOutlined, InstagramFilled } from '@ant-design/icons';
import { AutoReply } from "../../comps/automate/main";
import callAPI from "../../comps/fetch/main";
import { v4 as uuidv4 } from 'uuid';
import { fireDB } from "../../funcs/firebase";
import { getDocs , collection,doc, setDoc,deleteDoc} from "firebase/firestore";

import AccessOrNot from "../../funcs/accessOrNot";
import { template } from "lodash";

const { Title, Paragraph } = Typography;


function AutomationList() {


  let templates = {
    "comment_to_dm":{
      title: "Post/Reels - Comment to LinkDM",
      description: "Send links, products, images when someone comments on your Posts or Reels",
      items:[
        {
          "title":"Send Link as text message.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Send Link Button message.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Send More than one link.",
          "description": "Send plain text message as link.",
          "id":""
        },      
        {
          "title":"Send Multiple products links.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Collect Email from comment.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Collect Number from comment.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Collect Rating from comment.",
          "description": "Send plain text message as link.",
          "id":""
        },
      ]
    },
    "story_reply":{
      title: "Story Reply Auto DM",
      description: "Send links, products, images when someone comments on your Posts or Reels",
      items:[
        {
          "title":"Send Link as text message.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Send Link in Button message.",
          "description": "Send link in .",
          "id":""
        },
        {
          "title":"Send More than one link.",
          "description": "Send plain text message as link.",
          "id":""
        },      
        {
          "title":"Send Multiple products links.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Collect Email from story reply.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Collect Number from story reply.",
          "description": "Send plain text message as link.",
          "id":""
        },
        {
          "title":"Collect Rating from story reply.",
          "description": "Send plain text message as link.",
          "id":""
        },
      ]
    },
    "dm_reply":{
      title: "DM Auto Reply",
      description: "",
      items:[]
    },
    
    "global":{
      title: "Global Automation",
      description: "",
      items:[]
    },
    

  }


  const handleDuplicate = async (record) => {
    try {
        const user_detail = JSON.parse(localStorage.getItem("userData"));
        if (!user_detail?.user_id) {
            message.error("User ID not found.");
            return;
        }

        message.loading("Duplicating...")
        const newId = uuidv4();
        const userId = user_detail.user_id;
        const newAutomation = {
            ...record,
            id: newId,
            name: (record?.name || "Untitled") + " (Copy)",
            live: false,
            published_on: null,
        };

        const docRef = doc(fireDB, "automations", userId, "draft_automations", newId);
        await setDoc(docRef, newAutomation);
        message.destroy()
        message.success("Automation duplicated!");
        setData(prev => [newAutomation,...prev]);
    } catch (err) {
        console.error("Duplication error:", err);
        message.error("Failed to duplicate.");
    }
};


    const [isMobile, setIsMobile] = useState(window.innerWidth < 100);


    useEffect(() => {
      const handleResize = () => {
          setIsMobile(window.innerWidth < 768);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
  }, []);



    const [showDrawer, setShowDrawer] = useState(false)
    let default_template = {
        "dm_template_type": "text",
        "buttons": [
          {
            "title": "click to edit",
            "type": "web_url",
            "url": ""
          }
        ],
        "delay": "60",
        "reply_comments": [],
        "automate_all": "false",
        "enable": true,
        "triger_words": [
          "Link",
          "tool",
          "doc",
          "🔗"
        ],
        "welcome_message": {},
        "dms": [
          "hii"
        ],
        "enable_dm_reply": true,
        "enable_comment_reply": false,
        "dm_shared_reply": true,
        "followers_only": true
      }
    const [data, setData] = useState([
    ])

    const [selectedData, setSelectedData] = useState()

    const [initalState, setInitalState] = useState()

    const [publishing, setPublishing] = useState(false)
    const[callPostAPi, setCallPostAPi] = useState(false)

    const [dataPostedState,setDataPostedState] = useState()

    const [getFlowResult, setFlowListResult] = useState([])
    const [selectedFlowID, setSelectedFlowID] = useState()


    const [flowLoading, setFlowLoading] = useState(false)
    const [flowPublishedData, setFlowPublishedData] = useState({})

    useEffect(() => {
      if (getFlowResult?.data != undefined){
        messageApi.destroy();
        setFlowListResult(getFlowResult?.data)
        
      }
      
    },[getFlowResult])

    useEffect(() => {

      if(!selectedFlowID){
        return
      }

      messageApi.open({
        type: 'loading',
        content: 'Please wait, Loading...',
        duration: 0,
    });

    let apiURL = `/flow_editor_response?flow_id=${selectedFlowID}`
    
    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setFlowListResult })
    

    },[selectedFlowID])

    useEffect(() => {
        if (!callPostAPi || callPostAPi == undefined || callPostAPi == false) {
            return
        }
        messageApi.open({
            type: 'loading',
            content: 'Please wait updating',
            duration: 0,
        });
        let temp_data = {...selectedData}
        let payload = { ...data.automations[temp_data.index], auto_reply : temp_data?.auto_reply }


        // let apiURL = "/flow_editor"
        // console.log("payload======", payload)
        // localStorage.setItem("previous_config", JSON.stringify(payload))
        // callAPI({ url: apiURL, method: "GET", body: payload, loadingState: setLoading, dataState: setDataPostedState })
        setCallPostAPi(false)


    }, [callPostAPi])

    useEffect(() => {
        if(dataPostedState == undefined || dataPostedState == false){
            return
        }
        
        let temp_data = [...(data?.automations || [] )]
        if(selectedData.index){
          temp_data[selectedData.index].auto_reply = selectedData.auto_reply
          temp_data = {automations : [...temp_data]}
        }else{
          temp_data = {automations : [selectedData,...temp_data]}
          // console.log("=-=-=-=-=-=" , selectedData)
        }
              
        setData(temp_data)
        setShowDrawer(false)
        messageApi.destroy()
        
    }, [dataPostedState])


    const HandlePublish = () => {
        setCallPostAPi(true)
    }

    const [posting, setPosting] = useState(false)

    const getRandomColor = () => {
        const colors = [
          'magenta', "gold","lime","cyan","blue","geekblue","purple"
        ];
        return colors[Math.floor(Math.random() * colors.length)];
      };

    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState()


    const [expandedRow, setExpandedRow] = useState(null);

    const handleExpand = (expanded, record) => {
    if (expanded) {
        setExpandedRow(record.automate_id);
    } else {
        setExpandedRow(null);
    }
    };
    
   
    useEffect(() => {
      const fetchDraftAutomations = async () => {
          try {
              // Get user ID from local storage
              const user_detail = JSON.parse(localStorage.getItem("userData"));
              if (!user_detail?.user_id) {
                  console.error("User ID not found in local storage");
                  return;
              } 

              // console.log("calling flow editor" , )

              callAPI({url:"/flow_editor" , method:"GET" , loadingState:setFlowLoading, dataState:(data) => {
                let publishedPosts = {}
                data?.data?.map( (item) => {
                  let key = item.flow_id 
                  let name = item?.raw_flow_data?.name
                  let published_on = item?.raw_flow_data?.published_on
                  let live = item?.raw_flow_data?.live
                  publishedPosts [key] = {
                        name,
                        published_on,
                        live,
                        raw_flow_data:item?.raw_flow_data

                        }

              }); 
              setFlowPublishedData(publishedPosts)
            }})

              const userId = user_detail.user_id;
              
              // Reference to the draft_automations sub-collection
              const draftCollectionRef = collection(fireDB, "automations", userId, "draft_automations");

              // Fetch all documents in the collection (await required)
              const querySnapshot = await getDocs(draftCollectionRef);

              // Map through documents and get their data
              const drafts = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
              setData(drafts);
          } catch (error) {
              console.error("Error fetching draft automations:", error);
          }
      };

      fetchDraftAutomations();
  }, []); 

  function formatDate(istTimestamp) {
    // Convert IST timestamp string to a Date object
    let istDate = new Date(istTimestamp + " UTC"); // Convert IST to UTC

    // Convert to user's local time
    let localDate = new Date(istDate.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }));

    // Get user's local today & yesterday dates (without time)
    let today = new Date();
    today.setHours(0, 0, 0, 0);

    let yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    // Format time as "HH:MM AM/PM"
    let timeString = localDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });

    // Determine the final output
    if (localDate >= today) {
        return `Today ${timeString}`;
    } else if (localDate >= yesterday) {
        return `Yesterday ${timeString}`;
    } else {
        return localDate.toLocaleDateString() + " " + timeString; // Full date with time
    }
}


async function handleDelete(record) {

  async function DeleteFireStoreAndState(record) {
    try {
          const user_detail = JSON.parse(localStorage.getItem("userData"));
          if (user_detail?.user_id) {
            const draftDocRef = doc(
              fireDB,
              "automations",
              user_detail.user_id,
              "draft_automations",
              record.id
            );
            await deleteDoc(draftDocRef);
          }
        } catch (err) {
          console.error("Error deleting from Firestore:", err);
        }

        setData((prev) => {
          return prev.filter((item) => item.id !== record.id);
        })
  
      }
        callAPI({url:`/flow_editor?flow_id=${record?.id}` , method:"DELETE" , loadingState:() => {
          messageApi.loading("Deleting Flow...")
        }, dataState:async (data) => {
        
        messageApi.open("Deleting Flow...")
        data?.code == 200 && messageApi.success("Flow deleted successfully")
        DeleteFireStoreAndState(record)
        messageApi.destroy()
      }})

  

}

function getAutomationStatus(raw_flow_data){
  return (raw_flow_data?.nodes[0]?.data?.auto_reply?.comment_reply?.enabled  &&   ( raw_flow_data?.nodes[0]?.data?.auto_reply?.comment_reply?.triger_words?.length > 0  || raw_flow_data?.nodes[0]?.data?.auto_reply?.comment_reply?.automate_all == "true"  ) ||
              raw_flow_data?.nodes[0]?.data?.auto_reply?.dm_reply?.enabled  &&   (raw_flow_data?.nodes[0]?.data?.auto_reply?.dm_reply?.triger_words?.length > 0 || raw_flow_data?.nodes[0]?.data?.auto_reply?.dm_reply?.automate_all == "true"  ) ||
              raw_flow_data?.nodes[0]?.data?.auto_reply?.story_reply?.enabled  &&   (raw_flow_data?.nodes[0]?.data?.auto_reply?.story_reply?.triger_words?.length > 0 || raw_flow_data?.nodes[0]?.data?.auto_reply?.story_reply?.automate_all == "true"  )

              ) ? true : false
}
    
  const defaultColumns = [

    {
        title: 'Title',
        render: (_, record, index) => {


          let status = flowPublishedData[record.id]?.live || record?.live
          let raw_flow_data = flowPublishedData[record.id]?.raw_flow_data || record

          let an = flowPublishedData[record.id]?.name || record?.name

          return(
            <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start', gap:'0px'}}>
            <p style={{fontSize:"16px", fontWeight:"600"}}>  {an|| `Automation ${index+1}` } </p>
            <p style={{fontSize:"12px", opacity:".4", margin:"0"}}>#{record?.id}</p>
            {/* <Switch defaultValue={getAutomationStatus(raw_flow_data)}/> */}
          </div>
          )

        }

    },
    {
        title: 'Status',
        render: (_, record, index) => {

          let status = flowPublishedData[record.id]?.live || record?.live
          let raw_flow_data = flowPublishedData[record.id]?.raw_flow_data || record

          return(
            <p>  {status ?
            
            <div>            
             {getAutomationStatus(raw_flow_data)? <Tag color="green">Published</Tag> :  <Tag color="default">Draft</Tag>  }

            </div>
          

             : <Tag color="default">Draft</Tag>  } </p>
          )
        }



    },
    {
      title: 'Published on',
      render: (_, record, index) => 

        {
          let published_on = flowPublishedData[record.id]?.published_on || record?.published_on

        return (<p>  {published_on !=undefined && published_on.slice(0, 16) } </p> )
      
        }


  },
    {
        title: 'Actions',
      render: (_, record, index) => (
        <Space>
        
        <Popconfirm
          title="Are you sure you want to delete this automation?"
          onConfirm={() => handleDelete(record)}
          okText="Delete Automation"
          
        >
          <Button color="danger" variant="outlined" icon={<DeleteOutlined />} />
        </Popconfirm>
        

        <Button variant="dashed" icon={<CopyOutlined />} onClick={() => handleDuplicate(record)}/>

         <a href={`/flow?id=${record.id}`}> 
            <Button  icon={<EditOutlined />} variant="outlined"/>
         </a>


         {record?.live &&   <Button onClick={() => setSelectedFlowID(record.id)} icon={<EyeOutlined />} type="primary"> Contacts</Button> }
         
          
        </Space>
        
      ),     
    },
    
  ];

  const responseColumns = [
    {
      title: 'Contact Name',
      render: (_, record, index) => (
        <p>  {record?.sender_detail?.username || `NA` } </p>),
  },
  {
    title: 'Conversation Started at',
    render: (_, record, index) => (
      <p> {formatDate(record?.created_at)} </p>),
  },
  {
    title: 'Last Updated at',
    render: (_, record, index) => (
      <p>  {formatDate(record?.updated_at)} </p>),
  },

  {
    title: 'Action',
    render: (_, record, index) => (
    
      record?.sender_detail?.username != undefined &&

      <a target="_blank" href={`https://instagram.com/${record?.sender_detail?.username}`}>
      <InstagramFilled style={{color:"#c12f9e" ,fontSize:"24px"}} />
      </a>
    
      
    ),
  },

  ]

    const [hoveredRowId, setHoveredRowId] = useState(null);
    const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });
    const [showExamples, setShowExamples] = useState(false)


      if (isMobile) {
        return <Alert message="Please open on a laptop or computer for the best experience." type="error" showIcon />;
    }

    
    return (

        <>
        <div style={{width:"90%"}} className="desktop white-bg-border page-content hide-scrollbar">
            <div className="heading" style={{maxWidth:'90%'}}>
                <h1>Flow Automation - Posts & DM's</h1>
                <p style={{opacity:'.4', lineHeight:'24px',fontSize:'14px'}}>Collect Mail, phone, reviews, address, payments, screenshots, or anything and everything. With our brand new flow automation. <br/> InstantDM -  Manychat's #1 alternative.</p>
            </div>
            

            <div style={{display:'flex', flexDirection:'row', alignContent:'center', justifyContent:'space-between', padding:"10px 20px"}}>
                <h3>My Automations</h3>
                
                <div>
                {
                  AccessOrNot("flow_editor") ? 
                
                <a href={`/flow?id=${uuidv4()}`}>
                  <Button onClick={() => setShowExamples(false)} type="primary" style={{marginBottom:'20px'}}>New Automation</Button>
                </a>

                
                  // <Button onClick={() => setShowExamples(true)} type="primary" style={{marginBottom:'20px'}}>New Automation</Button>
                
                :

                
                <Button type="primary" style={{marginBottom:'20px'}}>Upgrade to paid plan</Button>
                

                }
                </div>
                
            </div>
            <div>

              <Table                
                  bordered
                  dataSource={data || []}
                  rowKey = "id"
                  columns={defaultColumns}
                    onRow={(record) => ({
                    onMouseEnter: (event) => {
                      const rect = event.currentTarget.getBoundingClientRect();
                      setHoveredRowId(record.id);
                      setPopoverPosition({ x: 100, y: rect.top});
                    },
                    onMouseLeave: () => setHoveredRowId(null),
                  })}
              />,

            </div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/JrtbVS1oZ2Q?si=m0_W9Y2VO4HLy0sr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            <Drawer
                    title={"DM automation"}
                    placement="right"
                    open={showDrawer}
                    style={{ backgroundColor: '#f5f5ff' }}
                    width={'600px'}
                    onClose={() => { setShowDrawer(false); }}
                    extra={
                        <Space>
                            <Button onClick={() => { setShowDrawer(false); }}>Cancel</Button>
                            <Button type="primary"
                                onClick={() => HandlePublish()} loading={posting}>
                                Publish
                            </Button>
                        </Space>
                    }
                >
                    <AutoReply state={selectedData} setData={setSelectedData} isStory={false} isNextPostReply={false} isDMAuto={true} AutomateAll={false}/>
                    {/* <AutoReply /> */}
        </Drawer>


        <Drawer 
        title={"Contacts"}
        // placement="right"
        open={selectedFlowID != undefined}
        style={{ backgroundColor: '#f5f5ff' }}
        width={'100%'}
        onClose={() => { setSelectedFlowID(undefined); }}
        >

        { getFlowResult instanceof Array &&

          <></>
        
        }



        { getFlowResult instanceof Array &&
              <Table                
                bordered
                dataSource={getFlowResult || []}
                rowKey = "parent_id"
                columns={responseColumns}
            />

        }

        </Drawer>
          <Modal
          title="Start with a template"
          width={"90%"}
          height={"90vh"}
          open={showExamples}
          onCancel={() => setShowExamples(false)}
          >

          <div style={{ padding: "24px" }}>
      {Object.entries(templates).map(([key, template]) => (
        <div key={key} style={{ marginBottom: "40px" }}>
          {/* Category Header */}
          <Title level={3}>{template.title}</Title>
          {template.description && (
            <Paragraph type="secondary">{template.description}</Paragraph>
          )}

          {/* Grid of Cards */}
          {template.items.length > 0 ? (
            <Row gutter={[16, 16]}>
              {template.items.map((item) => (
                <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                  <Card
                    cover={
                      <img
                        alt={item.title}
                        src={item.image}
                        style={{ height: 140, objectFit: "cover" }}
                      />
                    }
                    actions={[
                      <Button color="primary" variant="outline" key="select">
                        Use this template
                      </Button>
                    ]}
                  >
                    <Card.Meta
                      title={item.title}
                      description={item.description}
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <Empty description="No templates available yet" style={{ marginTop: 20 }} />
          )}
        </div>
      ))}
    </div>
 
          </Modal>

        </div>
        <div className="mobile white-bg-border">
          <Alert message="Please open on a laptop or computer for the best experience." type="error" showIcon />
        </div>
        </>

    )


}

export default AutomationList

